// 登录弹窗组件 LoginModal.tsx
import { useAtom } from 'jotai'
import { loginModalAtom } from '@/stores/auth'
import { useEffect } from 'react'

import { Modal, } from 'antd';
import styles from './LoginModal.module.css'; // 建议将样式抽离

import PhoneLoginForm from './PhoneLoginForm';
export const LoginModal = () => {
    const [visible, setVisible] = useAtom(loginModalAtom)
    useEffect(() => {
        const handleTrigger = () => {
            setVisible(true);
        };

        // 监听原生事件
        window.addEventListener('show-login-modal', handleTrigger);

        return () => {
            window.removeEventListener('show-login-modal', handleTrigger);
        };
    }, [setVisible]);
    const loginAfter = () => {
        setVisible(false)
        window.location.href = '/ai';

    }
    return (
        <Modal
            open={visible}
            onCancel={() => setVisible(false)}
            footer={null} // 隐藏默认的确定/取消按钮
            closable={true}
            centered
            width={400}
            bodyStyle={{ padding: 0, textAlign: 'center' }} // 去除内边距以适配背景图
        >
            <h2 className={styles.title}>登录</h2>
            <p className={styles.subtitle}>登录账号，解锁更多实用功能</p>
            <PhoneLoginForm loginAfter={loginAfter} />
            <div className={styles.agreement}>
                注册登录代表已阅读并同意我们的
                <a href="#">用户协议</a> 与 <a href="#">隐私政策</a>，
                未注册的手机号将自动注册
            </div>
        </Modal>
    );
}